var cov_v6tbls6nb = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/TreeSelect/Input.tsx",
      hash = "22a58bb0a8b97149490f4c882ffa0bf93ea236fc",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/TreeSelect/Input.tsx",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 21
        },
        end: {
          line: 9,
          column: 1
        }
      },
      "1": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 16
        }
      },
      "2": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 23,
          column: 50
        }
      },
      "3": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 24,
          column: 50
        }
      },
      "4": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 51
        }
      },
      "5": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 33,
          column: 5
        }
      },
      "6": {
        start: {
          line: 32,
          column: 6
        },
        end: {
          line: 32,
          column: 18
        }
      },
      "7": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 37,
          column: 31
        }
      },
      "8": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 73
        }
      },
      "9": {
        start: {
          line: 41,
          column: 67
        },
        end: {
          line: 41,
          column: 73
        }
      },
      "10": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 42,
          column: 16
        }
      },
      "11": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 57
        }
      },
      "12": {
        start: {
          line: 46,
          column: 26
        },
        end: {
          line: 46,
          column: 57
        }
      },
      "13": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 47,
          column: 52
        }
      },
      "14": {
        start: {
          line: 47,
          column: 24
        },
        end: {
          line: 47,
          column: 52
        }
      },
      "15": {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 53,
          column: 6
        }
      },
      "16": {
        start: {
          line: 52,
          column: 6
        },
        end: {
          line: 52,
          column: 43
        }
      },
      "17": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 57,
          column: 25
        }
      },
      "18": {
        start: {
          line: 61,
          column: 4
        },
        end: {
          line: 61,
          column: 90
        }
      },
      "19": {
        start: {
          line: 65,
          column: 38
        },
        end: {
          line: 65,
          column: 48
        }
      },
      "20": {
        start: {
          line: 66,
          column: 18
        },
        end: {
          line: 66,
          column: 83
        }
      },
      "21": {
        start: {
          line: 68,
          column: 4
        },
        end: {
          line: 76,
          column: 5
        }
      },
      "22": {
        start: {
          line: 69,
          column: 6
        },
        end: {
          line: 75,
          column: 8
        }
      },
      "23": {
        start: {
          line: 78,
          column: 4
        },
        end: {
          line: 89,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 20,
            column: 2
          },
          end: {
            line: 20,
            column: 3
          }
        },
        loc: {
          start: {
            line: 20,
            column: 33
          },
          end: {
            line: 28,
            column: 3
          }
        },
        line: 20
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 30,
            column: 2
          },
          end: {
            line: 30,
            column: 3
          }
        },
        loc: {
          start: {
            line: 30,
            column: 22
          },
          end: {
            line: 34,
            column: 3
          }
        },
        line: 30
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 36,
            column: 3
          }
        },
        loc: {
          start: {
            line: 36,
            column: 26
          },
          end: {
            line: 38,
            column: 3
          }
        },
        line: 36
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 40,
            column: 3
          }
        },
        loc: {
          start: {
            line: 40,
            column: 44
          },
          end: {
            line: 43,
            column: 3
          }
        },
        line: 40
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 45,
            column: 2
          },
          end: {
            line: 45,
            column: 3
          }
        },
        loc: {
          start: {
            line: 45,
            column: 10
          },
          end: {
            line: 48,
            column: 3
          }
        },
        line: 45
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 50,
            column: 2
          },
          end: {
            line: 50,
            column: 3
          }
        },
        loc: {
          start: {
            line: 50,
            column: 10
          },
          end: {
            line: 54,
            column: 3
          }
        },
        line: 50
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 51,
            column: 26
          },
          end: {
            line: 51,
            column: 27
          }
        },
        loc: {
          start: {
            line: 51,
            column: 32
          },
          end: {
            line: 53,
            column: 5
          }
        },
        line: 51
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 56,
            column: 2
          },
          end: {
            line: 56,
            column: 3
          }
        },
        loc: {
          start: {
            line: 56,
            column: 35
          },
          end: {
            line: 58,
            column: 3
          }
        },
        line: 56
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 60,
            column: 2
          },
          end: {
            line: 60,
            column: 3
          }
        },
        loc: {
          start: {
            line: 60,
            column: 51
          },
          end: {
            line: 62,
            column: 3
          }
        },
        line: 60
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 64,
            column: 2
          },
          end: {
            line: 64,
            column: 3
          }
        },
        loc: {
          start: {
            line: 64,
            column: 11
          },
          end: {
            line: 90,
            column: 3
          }
        },
        line: 64
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 31,
            column: 4
          },
          end: {
            line: 33,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 31,
            column: 4
          },
          end: {
            line: 33,
            column: 5
          }
        }, {
          start: {
            line: 31,
            column: 4
          },
          end: {
            line: 33,
            column: 5
          }
        }],
        line: 31
      },
      "1": {
        loc: {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 41,
            column: 73
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 41,
            column: 73
          }
        }, {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 41,
            column: 73
          }
        }],
        line: 41
      },
      "2": {
        loc: {
          start: {
            line: 41,
            column: 8
          },
          end: {
            line: 41,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 41,
            column: 8
          },
          end: {
            line: 41,
            column: 44
          }
        }, {
          start: {
            line: 41,
            column: 48
          },
          end: {
            line: 41,
            column: 65
          }
        }],
        line: 41
      },
      "3": {
        loc: {
          start: {
            line: 46,
            column: 4
          },
          end: {
            line: 46,
            column: 57
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 46,
            column: 4
          },
          end: {
            line: 46,
            column: 57
          }
        }, {
          start: {
            line: 46,
            column: 4
          },
          end: {
            line: 46,
            column: 57
          }
        }],
        line: 46
      },
      "4": {
        loc: {
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 47,
            column: 52
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 47,
            column: 52
          }
        }, {
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 47,
            column: 52
          }
        }],
        line: 47
      },
      "5": {
        loc: {
          start: {
            line: 66,
            column: 18
          },
          end: {
            line: 66,
            column: 83
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 66,
            column: 45
          },
          end: {
            line: 66,
            column: 76
          }
        }, {
          start: {
            line: 66,
            column: 79
          },
          end: {
            line: 66,
            column: 83
          }
        }],
        line: 66
      },
      "6": {
        loc: {
          start: {
            line: 68,
            column: 4
          },
          end: {
            line: 76,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 68,
            column: 4
          },
          end: {
            line: 76,
            column: 5
          }
        }, {
          start: {
            line: 68,
            column: 4
          },
          end: {
            line: 76,
            column: 5
          }
        }],
        line: 68
      },
      "7": {
        loc: {
          start: {
            line: 81,
            column: 44
          },
          end: {
            line: 81,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 81,
            column: 44
          },
          end: {
            line: 81,
            column: 53
          }
        }, {
          start: {
            line: 81,
            column: 57
          },
          end: {
            line: 81,
            column: 63
          }
        }],
        line: 81
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/TreeSelect/Input.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Component, isValidElement, cloneElement } from 'react';
import { focusElement, preventPasteFile } from '../utils/dom/element';
import { treeSelectClass } from './styles';
var DefaultValue = (cov_v6tbls6nb.s[0]++, {
  text: '',
  updatAble: false
});

var FilterInput =
/*#__PURE__*/
function (_Component) {
  _inherits(FilterInput, _Component);

  var _super = _createSuper2(FilterInput);

  function FilterInput(props) {
    var _this;

    _classCallCheck(this, FilterInput);

    cov_v6tbls6nb.f[0]++;
    cov_v6tbls6nb.s[1]++;
    _this = _super.call(this, props);
    _this.editElement = void 0;
    _this.blurTimer = void 0;
    _this.handleBlur = void 0;
    cov_v6tbls6nb.s[2]++;
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_this));
    cov_v6tbls6nb.s[3]++;
    _this.handleInput = _this.handleInput.bind(_assertThisInitialized(_this)); // for mutiple select

    cov_v6tbls6nb.s[4]++;

    _this.props.setInputReset(_this.reset.bind(_assertThisInitialized(_this)));

    return _this;
  }

  _createClass(FilterInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_v6tbls6nb.f[1]++;
      cov_v6tbls6nb.s[5]++;

      if (this.props.focus) {
        cov_v6tbls6nb.b[0][0]++;
        cov_v6tbls6nb.s[6]++;
        this.focus();
      } else {
        cov_v6tbls6nb.b[0][1]++;
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      cov_v6tbls6nb.f[2]++;
      cov_v6tbls6nb.s[7]++;
      return this.props.updatAble;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      cov_v6tbls6nb.f[3]++;
      cov_v6tbls6nb.s[8]++;

      if ((cov_v6tbls6nb.b[2][0]++, this.props.focus === prevProps.focus) || (cov_v6tbls6nb.b[2][1]++, !this.props.focus)) {
        cov_v6tbls6nb.b[1][0]++;
        cov_v6tbls6nb.s[9]++;
        return;
      } else {
        cov_v6tbls6nb.b[1][1]++;
      }

      cov_v6tbls6nb.s[10]++;
      this.focus();
    }
  }, {
    key: "reset",
    value: function reset() {
      cov_v6tbls6nb.f[4]++;
      cov_v6tbls6nb.s[11]++;

      if (this.editElement) {
        cov_v6tbls6nb.b[3][0]++;
        cov_v6tbls6nb.s[12]++;
        this.editElement.innerText = '';
      } else {
        cov_v6tbls6nb.b[3][1]++;
      }

      cov_v6tbls6nb.s[13]++;

      if (this.blurTimer) {
        cov_v6tbls6nb.b[4][0]++;
        cov_v6tbls6nb.s[14]++;
        clearTimeout(this.blurTimer);
      } else {
        cov_v6tbls6nb.b[4][1]++;
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      var _this2 = this;

      cov_v6tbls6nb.f[5]++;
      cov_v6tbls6nb.s[15]++;
      requestAnimationFrame(function () {
        cov_v6tbls6nb.f[6]++;
        cov_v6tbls6nb.s[16]++;
        focusElement.select(_this2.editElement);
      });
    }
  }, {
    key: "bindElement",
    value: function bindElement(el) {
      cov_v6tbls6nb.f[7]++;
      cov_v6tbls6nb.s[17]++;
      this.editElement = el;
    }
  }, {
    key: "handleInput",
    value: function handleInput(e) {
      cov_v6tbls6nb.f[8]++;
      cov_v6tbls6nb.s[18]++;
      this.props.onFilter(e.target.innerText.replace('\feff ', '').trim());
    }
  }, {
    key: "render",
    value: function render() {
      cov_v6tbls6nb.f[9]++;

      var _ref = (cov_v6tbls6nb.s[19]++, this.props),
          text = _ref.text,
          focus = _ref.focus,
          multiple = _ref.multiple;

      var value = (cov_v6tbls6nb.s[20]++, typeof text === 'string' ? (cov_v6tbls6nb.b[5][0]++, text.replace(/<\/?[^>]*>/g, '')) : (cov_v6tbls6nb.b[5][1]++, text));
      cov_v6tbls6nb.s[21]++;

      if (
      /*#__PURE__*/
      isValidElement(value)) {
        cov_v6tbls6nb.b[6][0]++;
        cov_v6tbls6nb.s[22]++;
        return (
          /*#__PURE__*/
          cloneElement(value, {
            className: treeSelectClass('input'),
            ref: this.bindElement,
            key: 'input',
            onInput: this.handleInput,
            contentEditable: focus
          })
        );
      } else {
        cov_v6tbls6nb.b[6][1]++;
      }

      cov_v6tbls6nb.s[23]++;
      return (
        /*#__PURE__*/
        React.createElement("span", {
          key: "input",
          className: treeSelectClass('input', (cov_v6tbls6nb.b[7][0]++, !multiple) && (cov_v6tbls6nb.b[7][1]++, 'full')),
          ref: this.bindElement,
          contentEditable: focus,
          onPaste: preventPasteFile,
          onInput: this.handleInput,
          onBlur: this.handleBlur,
          dangerouslySetInnerHTML: {
            __html: value
          },
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 79,
            columnNumber: 7
          }
        })
      );
    }
  }]);

  return FilterInput;
}(Component);

FilterInput.defaultProps = DefaultValue;
export default FilterInput;